import { ImageData } from 'constants/data/image.data';
import { Print } from 'constants/data/print.data';

export const isPrint = (image: ImageData | Print): image is Print => {
  return (image as Print).imageId !== undefined;
};
